// @flow
import React from 'react'

import AuthService from 'client/utils/auth-service'

import cookies from 'browser-cookies'

import { useSearchParams, useOutletContext } from 'react-router-dom'

import Form from './form'
import LoginPreProd from 'client/apps/preprod-login'

type LoginType = {
  auth: AuthService,
  client: {
    redirectUri: string,
    connections: Array<{
      connection: string,
      strategy: string
    }>
  }
}
const allowedDomains = ['lanetixstaging.com', 'lanetix.com']
const Login = (props: LoginType): any => {
  const { auth, client } = useOutletContext()
  const [searchParams] = useSearchParams()

  React.useEffect(() => {
    const callbackURL = searchParams.get('callbackURL')
    const mobile = searchParams.get('mobile')

    console.log('ooooops', searchParams, callbackURL)

    if (callbackURL) {
      const parsedUrl = new URL(callbackURL)
      const allowedDomainsPattern = allowedDomains.map(domain => `(${domain.replace('.', '\\.')})`).join('|')
      const domainRegex = new RegExp(`^([a-zA-Z0-9-]+\\.)*(${allowedDomainsPattern})$`)

      if (domainRegex.test(parsedUrl.hostname)) {
        cookies.set('callbackURL', callbackURL)
      } else {
        console.warn('Attempted to set callbackURL from unauthorized domain:', parsedUrl.hostname)
        cookies.erase('callbackURL')
      }
    } else {
      cookies.erase('callbackURL')
    }

    mobile ? cookies.set('mobile', mobile) : cookies.erase('mobile')
  }, [searchParams])

  return (
    <div className='login'>
      <div className='login__header'>
        <i className='icon icon--logo' />
        <h3>Welcome!</h3>
        <h4>Sign in to continue</h4>
      </div>
      <Form auth={auth} client={client} />
      <LoginPreProd client={client} />
    </div>
  )
}

Login.displayName = 'Login'

export default Login
